export default "__VITE_ASSET__DMLFWIN___"